export default "__VITE_PUBLIC_ASSET__719be630__"